import React from 'react';

const DashboardPage = () => (
  <div className="container py-5">
    <h2>Dashboard</h2>
    <p className="text-muted">M1 placeholder — engineering modules remain on the walkthrough.</p>
  </div>
);

export default DashboardPage;
